export default [
  {
    path: '/transit/create',
    name: 'transit-create',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/Transit/CreateTransitView.vue'),
    meta: {
      permission: 'logistics.add_transit',
      redirect: '/site/logistics/transit/create/'
    }
  },
  {
    path: '/transit/manifest/create',
    name: 'manifest-create',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Manifest/ManifestCreateView'),
    meta: { permission: 'api.add_inventorymanifest' }
  },
  {
    path: '/transit',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/Transit/TransitParent'),
    children: [
      {
        path: 'dashboard',
        name: 'transit-dashboard',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/TransitDashboard'),
        meta: {
          permission: 'logistics.view_transit',
          redirect: '/site/logistics/transit/overview/'
        }
      },
      {
        path: 'merge',
        name: 'transit-merge',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/MergeTransit/MergeTransitView.vue'),
        meta: { permission: 'logistics.view_transit' }
      },
      {
        path: 'outbound-list',
        name: 'outbound-list',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/Outbound/OutboundList.vue'),
        meta: {
          permission: 'logistics.view_transit',
          redirect: '/site/logistics/transit/'
        }
      },
      {
        path: 'transit-list',
        name: 'transit-list',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/TransitList/InboundList.vue'),
        meta: {
          permission: 'logistics.view_transit',
          redirect: '/site/logistics/transit/'
        }
      },
      {
        path: 'manifest-list/',
        name: 'manifest-list',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Manifest/ManifestList'),
        meta: { permission: 'api.view_inventorymanifest' }
      },
      {
        path: 'lot-manifest-list/',
        name: 'lot-manifest-list',
        component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Manifest/LotManifestList.vue'),
        meta: {
          permission: 'api.view_lotmanifest',
          redirect: '/site/lots/manifest/'
        }
      }
    ]
  },
  {
    path: '/carrier-list',
    name: 'carrier-list',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Carriers/CarrierList'),
    meta: {
      permission: 'logistics.view_carrier',
      redirect: '/site/logistics/carriers/'
    }
  },
  {
    path: '/broker-list',
    name: 'broker-list',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Brokers/BrokerList'),
    meta: {
      permission: 'logistics.view_broker',
      redirect: '/site/logistics/brokers/'
    }
  },
  {
    path: '/transit/transit-manifest/:id',
    name: 'transit-manifest',
    meta: {
      permission: 'logistics.view_transitmanifest',
      redirect: '/site/logistics/transit-manifests/{id}/'
    }
  },
  {
    path: '/transit/manifest/:id',
    name: 'manifest-view',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Manifest/ManifestView'),
    reverse: 'inventory_manifest-single'
  },
  {
    path: '/transit/manifest/:id/print',
    name: 'manifest-print',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Manifest/ManifestPrint')
  },
  {
    path: '/transit/transit-list/:id',
    name: 'transit-view',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Logistics/Transit/TransitView'),
    meta: {
      permission: 'logistics.view_transit',
      redirect: '/site/logistics/transit/{id}/'
    },
    reverse: 'transits-single'
  },
  {
    path: '/carrier/carrier-list/:id',
    name: 'carrier-view',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Carriers/CarrierView'),
    meta: {
      permission: 'logistics.view_carrier',
      redirect: '/site/logistics/carriers/{id}/'
    },
    reverse: 'carriers-single'
  },
  {
    path: '/transit/broker-list/:id',
    name: 'broker-view',
    component: () => import(/* webpackChunkName: "logistics-routes" */ '@/views/Brokers/BrokerView'),
    meta: {
      permission: 'logistics.view_broker',
      redirect: '/site/logistics/brokers/{id}/'
    },
    reverse: 'brokers-single'
  }
]
